import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import 'react-toastify/dist/ReactToastify.css';
import './css/Main.css';
import {RecoilRoot} from "recoil";

ReactDOM.render(<RecoilRoot><App /></RecoilRoot>, document.getElementById('root'));